module.exports = __webpack_public_path__ + "static/fonts/Fact-SemiExpandedLight.9454b16.eot";